/* SANIKB inquiry field validation, 2026-10-16. Runs before lead capture and form handlers. */
(function () {
  'use strict';
  if (window.SkContactValidation) return;
  var PHONE = 'input[type="tel"],input[name="contact[phone]"],input[name="contact[Phone]"],input[name="contact[WhatsApp]"]';
  var COMMENT = 'textarea[name="contact[Comment]"],textarea[name="contact[body]"],textarea[name="contact[Message]"],textarea[name="contact[message]"],textarea[name="contact[Meeting note]"],textarea[name="contact[Additional requirements]"],textarea[name="message"]';
  var invisible = /[\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFEFF]/g;
  var counter = 0;
  var language = (document.documentElement.lang || 'en').split('-')[0];
  var messages = {
    en: {phone:'Enter a phone number containing 8–15 digits.', comment:'Please tell us briefly what you need.', required:'Please complete this field.', email:'Enter a valid email address.', long:'Please keep your comment within {n} characters.', pending:'Please wait for your files to finish uploading.', fileError:'An attachment failed. Remove it or upload it again before sending.', busy:'Your inquiry is being submitted. Please wait.', unavailable:'Phone validation could not load. Please refresh this page and try again.'},
    fr: {phone:'Saisissez un numéro de téléphone comportant 8 à 15 chiffres.', comment:'Décrivez brièvement votre besoin.', required:'Veuillez remplir ce champ.', email:'Saisissez une adresse e-mail valide.', long:'Limitez votre commentaire à {n} caractères.', pending:'Veuillez attendre la fin du téléversement des fichiers.', fileError:'Une pièce jointe a échoué. Supprimez-la ou téléversez-la à nouveau avant l’envoi.', busy:'Votre demande est en cours d’envoi. Veuillez patienter.', unavailable:'La vérification du téléphone n’a pas pu être chargée. Actualisez la page et réessayez.'},
    de: {phone:'Geben Sie eine Telefonnummer mit 8–15 Ziffern ein.', comment:'Beschreiben Sie kurz, was Sie benötigen.', required:'Bitte füllen Sie dieses Feld aus.', email:'Geben Sie eine gültige E-Mail-Adresse ein.', long:'Bitte begrenzen Sie Ihren Kommentar auf {n} Zeichen.', pending:'Bitte warten Sie, bis Ihre Dateien vollständig hochgeladen sind.', fileError:'Ein Anhang konnte nicht hochgeladen werden. Entfernen Sie ihn oder laden Sie ihn vor dem Senden erneut hoch.', busy:'Ihre Anfrage wird gesendet. Bitte warten Sie.', unavailable:'Die Telefonnummernprüfung konnte nicht geladen werden. Laden Sie die Seite neu und versuchen Sie es erneut.'},
    es: {phone:'Introduzca un número de teléfono de 8 a 15 dígitos.', comment:'Indique brevemente qué necesita.', required:'Complete este campo.', email:'Introduzca una dirección de correo electrónico válida.', long:'Limite su comentario a {n} caracteres.', pending:'Espere a que termine la carga de los archivos.', fileError:'No se pudo cargar un archivo adjunto. Elimínelo o vuelva a cargarlo antes de enviar.', busy:'Su consulta se está enviando. Espere un momento.', unavailable:'No se pudo cargar la validación del teléfono. Actualice la página y vuelva a intentarlo.'},
    ar: {phone:'أدخل رقم هاتف يحتوي على 8 إلى 15 رقماً.', comment:'يرجى توضيح ما تحتاج إليه بإيجاز.', required:'يرجى إكمال هذا الحقل.', email:'أدخل عنوان بريد إلكتروني صالحاً.', long:'يرجى ألا يتجاوز تعليقك {n} حرفاً.', pending:'يرجى الانتظار حتى يكتمل رفع الملفات.', fileError:'تعذر رفع أحد المرفقات. احذفه أو أعد رفعه قبل الإرسال.', busy:'جارٍ إرسال استفسارك. يرجى الانتظار.', unavailable:'تعذر تحميل التحقق من رقم الهاتف. حدّث الصفحة ثم حاول مرة أخرى.'}
  };
  var ORDER_VOLUMES = ["20ft full container", "20ft mixed container", "40ft full container", "40ft mixed container", "Own China freight forwarder"];
  var m = messages[language] || messages.en;
  var placeholders = {en:'Phone number',fr:'Numéro de téléphone',de:'Telefonnummer',es:'Número de teléfono',ar:'رقم الهاتف'};
  function simplePhone(raw) {
    var input=String(raw == null ? '' : raw).replace(/\uff0b/g,'+').replace(/[\u0660-\u0669\u06f0-\u06f9\uff10-\uff19]/g,function(d){
      var n=d.charCodeAt(0);return String(n-(n>=0xff10?0xff10:n>=0x06f0?0x06f0:0x0660));
    }).trim();
    if(!input)return {valid:false,code:'EMPTY',normalized:''};
    if(input.length>128 || !/^[0-9+().\- \u00a0\u2000-\u200a\u202f\u3000]+$/.test(input))return {valid:false,code:'INVALID_CHARACTERS',normalized:''};
    var compact=input.replace(/[().\- \u00a0\u2000-\u200a\u202f\u3000]/g,'');
    if(!/^\+?[0-9]+$/.test(compact))return {valid:false,code:'INVALID_CHARACTERS',normalized:''};
    if(compact.indexOf('00')===0)compact='+'+compact.slice(2);
    var digits=compact.replace(/^\+/,'');
    if(digits.length<8 || digits.length>15 || /^0+$/.test(digits))return {valid:false,code:'INVALID_LENGTH',normalized:''};
    var result={valid:true,code:'OK',normalized:compact,country:null,international:compact.charAt(0)==='+'};
    // Only an explicit international prefix can identify a numbering country. Never guess from IP or locale.
    if(result.international && window.SkPhoneCore && typeof window.SkPhoneCore.validate==='function'){
      try{var parsed=window.SkPhoneCore.validate(compact);if(parsed.valid){result.normalized=parsed.e164;result.country=parsed.country;}}catch(_){}
    }
    return result;
  }
  function visibleText(value) { return String(value || '').replace(invisible, '').trim(); }
  function isInquiry(form) {
    return !!(form && form.tagName === 'FORM' && form.querySelector(PHONE) &&
      (form.hasAttribute('data-inquiry-form') || form.querySelector('input[name="form_type"][value="contact"]') || /\/contact(?:[?#]|$)/.test(form.action || '')));
  }
  function errorNode(field) {
    if (field.__skErrorNode) return field.__skErrorNode;
    var node = document.createElement('span');
    node.className = 'sk-validation-error';
    node.id = 'sk-validation-error-' + (++counter);
    node.hidden = true;
    node.setAttribute('aria-live', 'polite');
    var entry = field.__skPhoneEntry || field;
    entry.insertAdjacentElement('afterend', node);
    var descriptions = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    descriptions.push(node.id);
    field.setAttribute('aria-describedby', descriptions.join(' '));
    field.__skErrorNode = node;
    return node;
  }
  function show(field, message, reveal) {
    field.setCustomValidity(message);
    field.__skOwnValidity = true;
    var node = errorNode(field);
    node.textContent = message;
    node.hidden = !(message && reveal);
    field.setAttribute('aria-invalid', message && reveal ? 'true' : 'false');
    field.classList.toggle('sk-validation-invalid', !!(message && reveal));
    return !message;
  }
  function fieldMessage(field) {
    if (field.disabled || field.type === 'hidden' || /^(?:submit|button|reset|file)$/.test(field.type)) return '';
    var value = visibleText(field.value);
    if(field.matches('[data-sk-order-volume]'))return ORDER_VOLUMES.indexOf(value)!==-1 ? '' : (field.getAttribute('data-sk-order-error') || m.required);
    if (field.matches(PHONE)) {
      field.__skPhoneResult = null;
      if (!value && !field.required) {field.value='';return '';}
      var result = simplePhone(field.value);
      field.__skPhoneResult = result;
      if (result.valid) return '';
      return m.phone;
    }
    if (field.matches(COMMENT)) {
      if (field.required && !value) return m.comment;
      var max = Number(field.getAttribute('maxlength')) || 5000;
      if (Array.from(String(field.value || '')).length > max) return m.long.replace('{n}', String(max));
      return '';
    }
    if (field.type === 'email') {
      field.value = String(field.value || '').trim();
      if ((!value && field.required) || (value && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || field.validity.typeMismatch))) return m.email;
      return '';
    }
    if (field.required && !/^(checkbox|radio)$/.test(field.type) && !value) return m.required;
    return '';
  }
  function validateField(field, reveal) {
    if(field.disabled || field.type === 'hidden' || field.hidden || /^(?:submit|button|reset|file)$/.test(field.type)) return true;
    // Preserve section-specific checkbox/number/custom validity (meeting day/time, calculator quantities).
    if (field.matches(PHONE) || field.matches(COMMENT) || field.type === 'email' ||
        (field.required && !/^(?:checkbox|radio|number|hidden)$/.test(field.type))) {
      return show(field, fieldMessage(field), reveal);
    }
    return field.disabled || !field.willValidate || field.validity.valid;
  }
  function mountPhone(field) {
    if(field.__skSimplePhone)return;
    field.__skSimplePhone=true;
    field.setAttribute('dir','ltr');field.setAttribute('inputmode','tel');
    field.setAttribute('placeholder',placeholders[language]||placeholders.en);
    field.removeAttribute('title');field.removeAttribute('pattern');
    if(!field.hasAttribute('maxlength'))field.setAttribute('maxlength','80');
  }
  function setup(form) {
    if (!isInquiry(form)) return;
    // The Canton Fair meeting request does not require a procurement plan.
    if(form.id !== 'CfMeetingForm' && !form.querySelector('[data-sk-order-volume]')){
      var template=document.getElementById('sk-container-order-policy-template');
      if(template && template.content)form.insertBefore(template.content.cloneNode(true),form.firstChild);
    }
    var volume=form.querySelector('[data-sk-order-volume]');
    if(volume){volume.disabled=false;volume.hidden=false;volume.required=true;}
    var option=form.querySelector('[data-sk-forwarder-option]');
    if(option)option.disabled=false;
    // Selection is the declaration; sales confirms details later. Remove stale cached detail controls.
    form.querySelectorAll('[data-sk-forwarder-fields],[data-sk-forwarder-disclosure]').forEach(function(node){node.remove();});
    form.querySelectorAll('[data-sk-validation-loading]').forEach(function(node){node.remove();});
    form.querySelectorAll(PHONE).forEach(mountPhone);
    form.querySelectorAll('input,select,textarea').forEach(function (field) {
      if (field.__skValidationWired || field.type === 'hidden' || field.type === 'file') return;
      field.__skValidationWired = true;
      if(field.matches(COMMENT)&&field.required&&!field.hidden){
        field.setAttribute('aria-required','true');
        var label=field.labels&&field.labels[0];
        if(label&&label.textContent.indexOf('*')===-1){var mark=document.createElement('span');mark.className='sk-required-mark';mark.textContent=' *';mark.setAttribute('aria-hidden','true');label.appendChild(mark);}
      }
      field.addEventListener('input', function () {
        validateField(field, !!field.__skTouchedValidation || !!form.__skValidationAttempted);
        if (form.__skSubmissionNotice) form.__skSubmissionNotice.hidden = true;
      });
      field.addEventListener('blur', function () { field.__skTouchedValidation = true; validateField(field,true); });
      field.addEventListener('change', function () { validateField(field, !!field.__skTouchedValidation || !!form.__skValidationAttempted); });
      field.addEventListener('invalid', function () { validateField(field,true); });
    });
    if (!form.__skValidationReset) {
      form.__skValidationReset = true;
      form.addEventListener('reset', function () { setTimeout(function () {
        form.__skValidationAttempted = false; form.__skSubmitPendingAt = 0; form.__skSubmitPendingToken = null;
        if(form.__skSubmissionNotice)form.__skSubmissionNotice.hidden=true;
        form.querySelectorAll('.sk-validation-error').forEach(function (node) {node.hidden=true;});
        form.querySelectorAll('input,select,textarea').forEach(function (field) {
          field.__skTouchedValidation = false;
          field.__skPhoneResult = null;
          if (field.__skOwnValidity) field.setCustomValidity('');
          field.removeAttribute('aria-invalid'); field.classList.remove('sk-validation-invalid');
        });
      },0); });
    }
  }
  function notice(form, message) {
    var node = form.__skSubmissionNotice;
    if (!node) {
      node=document.createElement('p');node.className='sk-validation-notice';node.setAttribute('role','alert');
      var button=form.querySelector('[type="submit"]'); if(button)button.insertAdjacentElement('beforebegin',node);else form.appendChild(node);
      form.__skSubmissionNotice=node;
    }
    node.textContent=message;node.hidden=false;
  }
  function cancel(event, preserveAccepted) {
    event.preventDefault();event.stopImmediatePropagation();
    // A rejected attempt must not leave a previous contact attempt queued for conversion.
    if(!preserveAccepted)try {sessionStorage.removeItem('skLeadAM');sessionStorage.removeItem('skLeadAMq');} catch (_) {}
  }
  function onSubmit(event) {
    var form=event.target;
    if (!isInquiry(form)) return;
    setup(form);form.__skValidationAttempted=true;
    if(form.id !== 'CfMeetingForm' && !form.querySelector('[data-sk-order-volume]')){cancel(event);notice(form,m.unavailable);return;}
    var calculator=form.closest('[data-skto-root]');
    if(calculator && (typeof calculator.__sktoPrepareSubmit !== 'function' || !calculator.__sktoPrepareSubmit())) {cancel(event);return;}
    var first=null;
    form.querySelectorAll('input,select,textarea').forEach(function(field){
      if(!validateField(field,true)&&!first)first=field;
    });
    if(first){cancel(event);try{first.focus();first.reportValidity();}catch(_){}return;}
    if (form.querySelector('[data-sk-att-list] .sp')) {cancel(event);notice(form,m.pending);return;}
    if (form.querySelector('[data-sk-att-list] .is-err')) {cancel(event);notice(form,m.fileError);return;}
    if (form.__skSubmitPendingToken && Date.now()-form.__skSubmitPendingToken.at < 12000) {cancel(event,true);notice(form,m.busy);return;}
    form.querySelectorAll(PHONE).forEach(function(field){
      if(visibleText(field.value)&&field.__skPhoneResult&&field.__skPhoneResult.valid)field.value=field.__skPhoneResult.normalized;
    });
    // Lock synchronously against reentrant/double clicks. A deferred captcha or rejected event releases its token.
    var token={at:Date.now()};form.__skSubmitPendingToken=token;form.__skSubmitPendingAt=token.at;
    setTimeout(function(){if(event.defaultPrevented&&form.__skSubmitPendingToken===token){form.__skSubmitPendingToken=null;form.__skSubmitPendingAt=0;}},0);
  }
  function scan(){document.querySelectorAll('form').forEach(setup);}
  window.SkContactValidation={onSubmit:onSubmit,scan:scan,isInquiry:isInquiry,validateField:validateField,messages:m,validatePhone:simplePhone,version:'20261022.plans.2'};
  if(!window.__skContactEarlyGuard)window.addEventListener('submit',onSubmit,true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  var queued=false;
  try {new MutationObserver(function(records){
    if(queued||!records.some(function(record){return record.addedNodes.length;}))return;
    queued=true;requestAnimationFrame(function(){queued=false;scan();});
  }).observe(document.documentElement,{childList:true,subtree:true});}catch(_){}
  window.addEventListener('pageshow',function(){document.querySelectorAll('form').forEach(function(form){form.__skSubmitPendingAt=0;form.__skSubmitPendingToken=null;});scan();});
})();
